/**
 * @copyright © Paramount Streaming
 * @description Constants for Conveyor pipeline keys used throughout the Tag application
 */

/**
 * @description Conveyor pipeline key for processing paramsVO during video load
 * This pipeline is used to transform and enrich the paramsVO object before
 * resource configuration is built and video playback begins
 */
export const CONVEYOR_KEY_API_VIDEO_LOAD_PARAMS_VO = 'API.VIDEO.load > paramsVO';